import { avoidBreakInside } from '@provider/print';
import { makeHtmlNodeToJsxPrinter, generateJsxKey, printAST, textNodeToJsxPrinter } from '@utils/ast';
import { boxPrinters } from '../../ast/spec.box.js';
import { fontPrinters } from '../../ast/spec.font.js';
import { latexFormula } from '../../ast/spec.image.comp.style.js';
import { img, link, boxWrapper } from './molecule.context.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const htmlNodePrinter = makeHtmlNodeToJsxPrinter(undefined, () => printPrinters);
const basePrinters = {
  text: textNodeToJsxPrinter,
  html: htmlNodePrinter
};
const printPrinters = {
  ...basePrinters,
  video23: () => null,
  "medialibrary.video": () => null,
  "medialibrary.audio": () => null,
  img: (node, context) => {
    const image = node.latex ?
    /*#__PURE__*/
    // eslint-disable-next-line @next/next/no-img-element
    jsx("img", {
      role: "presentation",
      alt: node.alt ?? "",
      src: node.src,
      "data-latex": node.latex,
      className: latexFormula
    }) :
    /*#__PURE__*/
    // eslint-disable-next-line @next/next/no-img-element
    jsx("img", {
      alt: "",
      src: node.src,
      className: img
    });
    if (!node.caption) {
      return /*#__PURE__*/jsx("div", {
        children: image
      }, generateJsxKey(context));
    }
    return /*#__PURE__*/jsxs("div", {
      children: [image, /*#__PURE__*/jsx("div", {
        children: printAST(node.caption, printPrinters)
      })]
    }, generateJsxKey(context));
  },
  link: (node, context) => {
    return /*#__PURE__*/jsx("a", {
      href: node.href ?? "",
      className: link,
      children: context.printChildren(node.children, printPrinters)
    }, generateJsxKey(context));
  },
  box: (node, context) => {
    return /*#__PURE__*/jsx("div", {
      className: boxWrapper,
      ...avoidBreakInside(),
      children: boxPrinters.box(node, context)
    }, generateJsxKey(context));
  },
  ...fontPrinters
};

export { printPrinters };
//# sourceMappingURL=ast.printers.js.map
